export const SPECS = {
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  UseIsShippableInCartPage: 'specs.ecom.UseIsShippableInCartPage',
  ShowCssPerBreakpointIndicationsSideCart: 'specs.stores.ShowCssPerBreakpointIndicationsSideCart',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  UseProductThumbnailWithWowImage: 'specs.stores.UseProductThumbnailWithWowImage',
  FixHandleCreateCheckoutError: 'specs.ecom.FixHandleCreateCheckoutError',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  FixCouponCss: 'specs.ecom.FixCouponCss',
  EmptyCartA11yFix: 'specs.ecom.EmptyCartA11yFix',
  SideCartCouponAndNote: 'specs.ecom.SideCartCouponAndNote',
  SideCartNote: 'specs.ecom.SideCartNote',
  UseAdditionalEcommerceSettings: 'specs.ecom.UseAdditionalEcommerceSettings',
  FixExpressWrongTotalAmount: 'specs.ecom.FixExpressWrongTotalAmount',
  SideCartEditor3SettingsPanel: 'specs.ecom.SideCartEditor3SettingsPanel',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  StopUsingPaymentMethodsInCart: 'specs.ecom.StopUsingPaymentMethodsInCart',
  MoveGetClientConfigToControllerFactory: 'specs.ecom.MoveGetClientConfigToControllerFactory',
  ExpressCheckoutButtonsSkeleton: 'specs.ecom.ExpressCheckoutButtonsSkeleton',
  PreloadOnCartCheckoutButton: 'specs.ecom.PreloadOnCartCheckoutButton',
  RemoveBackgroudColorCartItemThumbnail: 'specs.ecom.RemoveBackgroudColorCartItemThumbnail',
  FixExpressCheckoutButtonOnEditor: 'specs.ecom.FixExpressCheckoutButtonOnEditor',
  MoveCartToViewerContext: 'specs.ecom.MoveCartToViewerContext',
  ShowModalWhenNoPremiumForExpressOnCart: 'specs.ecom.ShowModalWhenNoPremiumForExpressOnCart',
  FixTypingTextInNoteFieldIsBuggy: 'specs.ecom.FixTypingTextInNoteFieldIsBuggy',
  SendBIForPromoCodeAndNoteDisplay: 'specs.ecom.SendBIForPromoCodeAndNoteDisplay',
  DontUseLineItemEnricherInCartAndCheckout: 'specs.ecom.DontUseLineItemEnricherInCartAndCheckout',
  AddSlotsToSideCart: 'specs.ecom.AddSlotsToSideCart',
  SupportSubscriptionsInPurchaseFlow: 'specs.ecom.SupportSubscriptionsInPurchaseFlow',
  FixSecureCheckoutBadgeColor: 'specs.ecom.FixSecureCheckoutBadgeColor',
  UseLinkFromCartItem: 'specs.ecom.UseLinkFromCartItem',
  ExpressButtonsInternalLoaderInCart: 'specs.ecom.ExpressButtonsInternalLoaderInCart',
  MakeOnLoadWaitForLoaderToDisappearInExpress: 'specs.ecom.MakeOnLoadWaitForLoaderToDisappearInExpress',
  FixGoToCheckoutButtonFontWeight: 'specs.ecom.FixGoToCheckoutButtonFontWeight',
  OnlyCallDeliverySolutionsWhenNeededOnCart: 'specs.ecom.OnlyCallDeliverySolutionsWhenNeededOnCart',
} as const;
